import axios from "axios";
const api = axios.create({
  baseURL: `${window.location.origin}/api/public/api/`
  // baseURL: `http://127.0.0.1:8000/api/`
  // baseURL: "http://localhost/ponto-digital/api/public/api/",
});

export default api;
